import { render, staticRenderFns } from "./NewRecharge.vue?vue&type=template&id=b8480a1c&scoped=true"
import script from "./NewRecharge.vue?vue&type=script&lang=js"
export * from "./NewRecharge.vue?vue&type=script&lang=js"
import style0 from "./NewRecharge.vue?vue&type=style&index=0&id=b8480a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8480a1c",
  null
  
)

export default component.exports